export const PipelineTemplates = {
  addExtendedAttributes: require('../bake/modal/addExtendedAttribute.html'),
};
